module.exports = __webpack_public_path__ + "static/media/ee_desk_s.141ca1df.png";